import {get, post} from "../APIGateWay";
import {PAGE_LIMIT} from '../constant'

export async function getGradeBooks(data) {
    return await post(data, '/gradebook/parent-grade-book')
}
